import type { Dictionary, FileType } from '@witmetrics/utils';
import {
  getFileType,
  isScan,
  isSweethSequence,
  isViewableNonScan,
} from '@witmetrics/utils/files';
import { asyncMap, mapToKey } from '@witmetrics/utils/arrays';
import { FILE_TYPES } from '@witmetrics/utils/constants';
import type { LoadedFile } from '@/providers/LoadedFilesProvider';
import { uploadFileToFileCollection } from '@/utils/files';
import { loadScan } from '@/utils/scans';

export const classes = {
  auroraButton:
    'size-8 rounded-[9px] text-taupe-2 transition-colors hover:bg-black/[0.06] hover:text-taupe-3 dark:text-mauve-2 dark:hover:bg-white/[0.06] dark:hover:text-mauve-1',
};

export async function uploadFiles(
  accountId: number,
  fileCollectionId: number,
  files: File[],
  fileTypeOverride?: FileType
) {
  // Optionally pass a fileTypeOverride to ignore the file extension
  const data = await asyncMap(files, (file) =>
    uploadFileToFileCollection(
      file,
      accountId,
      fileCollectionId,
      FILE_TYPES[fileTypeOverride || getFileType(file.name)].id
    )
  );
  let loadedFiles: Dictionary<LoadedFile> = {};
  data.forEach(({ file, fileVersion, buffer }) => {
    if (isScan(fileVersion.name)) {
      loadedFiles[file.id] = loadScan(
        fileVersion.name,
        buffer,
        file.fileTypeId
      )!;
    } else if (isViewableNonScan(fileVersion.name)) {
      loadedFiles[file.id] = URL.createObjectURL(new Blob([buffer]));
    } else if (isSweethSequence(file)) {
      loadedFiles[file.id] = new Blob([buffer]);
    }
  });
  return {
    files: mapToKey(data, 'file'),
    fileCollectionFiles: mapToKey(data, 'fileCollectionFile'),
    fileVersions: mapToKey(data, 'fileVersion'),
    loadedFiles,
  };
}
